/*
 * Project: forca
 * File Created: Wednesday, 1st December 2021 2:13:38 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import { RelatedArticlesContainerProps } from './relatedArticles.definition';

import RelatedArticles from './relatedArticles.component';

export const RelatedArticlesContainer = (props: RelatedArticlesContainerProps) => {
	const containerProps = () => {
		const {
			articles = null,
			currentBlock = null,
			relateredeArtikler = []
		} = props;

		// if coming as a block
		if (currentBlock) {
			return {
				title: currentBlock?.overskrift,
				articles: relateredeArtikler,
				linkToOverviewText: currentBlock?.linkToOverviewText,
				linkToOverview: currentBlock?.linkToOverviewUrl,
				isBlock: true,
				elementMargin: currentBlock?.elementMargin
			};
		}

		// if coming as ditpka page
		if (!articles) {
			return props;
		}

		const {
			title,
			articles: {
				relateredeArtikler: relatedArticles
			},
			linkToOverviewText,
			linkToOverview
		} = props;

		return {
			title,
			articles: relatedArticles || [],
			linkToOverviewText,
			linkToOverview
		};
	};

	return (
		<RelatedArticles
			{ ...containerProps() }
		/>
	);
};

export default RelatedArticlesContainer;
